<template>
  <a-card>
    <a-form layout="inline" class="search-form">
      <a-form-item label="机构名称">
        <a-select v-model="searchForm.organizationId" placeholder="请选择机构名称" show-search :filter-option="filterOption" allowClear>
          <a-select-option v-for="item in orgList" :key="item.id" :value="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="考试名称">
        <a-input placeholder="请输入考试名称" v-model="searchForm.examName" :maxLength="35" />
      </a-form-item>
      <a-form-item label="学期">
        <a-select v-model="searchForm.term" placeholder="请选择考试学期" allowClear>
          <a-select-option :value="1"> 上学期 </a-select-option>
          <a-select-option :value="2"> 下学期 </a-select-option>
          <a-select-option :value="0"> 其他 </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="考试类型">
        <a-select v-model="searchForm.type" placeholder="请选择考试类型" allowClear>
          <a-select-option :value="0"> 普通小考 </a-select-option>
          <a-select-option :value="1"> 期末考试</a-select-option>
          <a-select-option :value="2"> 期中考试 </a-select-option>
          <a-select-option :value="3"> 中高考模拟考 </a-select-option>
          <a-select-option :value="4"> 开学摸底考 </a-select-option>
          <a-select-option :value="5"> 分班考试 </a-select-option>
          <a-select-option :value="6"> 区域统考 </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="考试时间">
        <a-range-picker v-model="searchForm.examTime" />
      </a-form-item>
      <a-form-item label="负责人">
        <a-select show-search :filter-option="filterOption" allowClear v-model="searchForm.operatorId" placeholder="请选择负责人">
          <a-select-option :value="item.adminId" v-for="item in adminList" :key="item.id">
            {{ item.adminName }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="状态" v-if="isCheckDataPermission">
        <a-select v-model="searchForm.status" placeholder="请选择状态" allowClear>
          <a-select-option :value="null"> 全部 </a-select-option>
          <a-select-option :value="false"> 未核实 </a-select-option>
          <a-select-option :value="true"> 已核实 </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="getList(1)">查询</a-button>
        <a-button style="margin-left: 16px" @click="handleReset">重置</a-button>
        <a-button type="primary" v-permission="`grade.upload`" style="margin-left: 16px" @click="handleUploadGrade">上传成绩</a-button>
      </a-form-item>
    </a-form>
    <a-row>
      <a-col :span="24">
        <a-table :columns="columns" :pagination="tableRelevant.tablePagination" :loading="tableRelevant.tableLoading" :locale="tableRelevant.locale" :dataSource="tableRelevant.tableDataSource">
          <div slot="status" slot-scope="text">
            <a-dropdown>
              <div class="action a-status">
                <span v-if="!text.status" type="link" class="c-red"> 未核实 <a-icon type="down" /></span>
                <span v-else type="link" class="c-theme"> 已核实 <a-icon type="down" /></span>
              </div>
              <a-menu slot="overlay">
                <a-menu-item :disabled="text.status" @click="handleChangeStatus(text, 0)">
                  <span type="link" :class="{ 'c-theme': !text.status }"> 已核实</span>
                </a-menu-item>
                <a-menu-item class="action" :disabled="!text.status" @click="handleChangeStatus(text, 1)">
                  <span type="link" :class="{ 'c-red': text.status }"> 未核实 </span>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
          <div slot="type" slot-scope="record">
            {{
              record.type === 0
                ? '普通小考'
                : record.type === 1
                ? '期末考试'
                : record.type === 2
                ? '期中考试'
                : record.type === 3
                ? '中高考模拟考'
                : record.type === 4
                ? '开学摸底考'
                : record.type === 5
                ? '分班考试'
                : record.type === 6
                ? '区域统考'
                : '其他'
            }}
          </div>
          <div slot="term" slot-scope="record">
            {{ record.term === 1 ? '上学期' : record.term === 2 ? '下学期' : '其他' }}
          </div>
          <div slot="remark" slot-scope="record">
            <a-tooltip>
              <template slot="title"> {{ record.remark }}</template>
              <div class="remark">
                {{ record.remark || '--' }}
              </div>
            </a-tooltip>
          </div>
          <div slot="examTime" slot-scope="record">
            <div class="remark">
              {{ record.examTime.split(' ')[0] }}
            </div>
          </div>
          <div slot="action" class="action" slot-scope="text, record">
            <template>
              <a-popconfirm title="确认要删除此成绩吗？" v-if="text.operatorId === user.id || $auth(`grade.delete`)" @confirm="onDelete(text)" ok-text="确认" cancel-text="取消">
                <a-button type="link" class="c-red" icon="delete" danger v-if="text.operatorId === user.id || $auth(`grade.delete`)"> 删除 </a-button>
              </a-popconfirm>
              <a-button type="link" icon="edit" v-if="text.operatorId === user.id || $auth(`grade.edit`)" @click="onEdit(text)"> 编辑 </a-button>
              <a-button type="link" :loading="text.downLoadLoading" v-if="text.operatorId === user.id || $auth(`grade.download`)" icon="download" @click="onDownload(text)"> 下载数据 </a-button>
            </template>
          </div>
        </a-table>
      </a-col>
    </a-row>
    <upload-grade ref="uploadGradeRef" />
  </a-card>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import uploadGrade from '../../reportCenter/groupReport_new/components/uploadGrade.vue'
import moment from 'moment'
import { mapState } from 'vuex'
import { arrayToXlsx } from '@/utils/util'

const columns = [
  {
    dataIndex: 'examName',
    title: '考试名称',
    width: 180,
    ellipsis: true,
  },
  {
    dataIndex: 'organziationName',
    title: '机构名称',
  },
  {
    scopedSlots: { customRender: 'term' },
    title: '学期',
  },
  {
    scopedSlots: { customRender: 'type' },
    title: '考试类型',
  },
  {
    dataIndex: 'operatorName',
    title: '负责人',
  },
  {
    scopedSlots: { customRender: 'examTime' },
    title: '考试时间',
  },
  {
    title: '备注',
    scopedSlots: { customRender: 'remark' },
    width: 240,
  },
  {
    scopedSlots: { customRender: 'status' },
    title: '状态',
  },
  {
    scopedSlots: { customRender: 'action' },
    title: '操作',
    width: 260,
  },
]
export default {
  components: { uploadGrade },
  data() {
    return {
      tableRelevant: tableRelevant.call(this, this.getList),
      adminList: [],
      orgList: [],
      searchForm: {
        term: undefined,
        type: undefined,
        examName: undefined,
        examTime: undefined,
        operatorId: undefined,
        status: null,
      },
      columns,
    }
  },
  computed: {
    ...mapState('account', ['permissions', 'user']),
    isCheckDataPermission() {
      return this.$auth('grade.checkData')
    },
  },
  created() {
    if (!this.isCheckDataPermission) {
      this.columns = columns.filter((item) => item.title !== '状态')
    }
    this.getAdminList()
    this.getList()
    this.getOrgList()
  },
  methods: {
    async getList(reset) {
      if (reset) {
        this.tableRelevant.tablePagination.current = 1
      }
      const params = {
        pageIndex: this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      }
      if (params.examTime) {
        params.examTime = params.examTime?.map((item) => moment(item).format('YYYY-MM-DD'))
        params.startTime = params.examTime?.[0]
        params.endTime = params.examTime?.[1]
      }
      delete params.examTime
      this.tableRelevant.tableLoading = true
      const { data } = await this.$http.ReportService.getGradeExam(params).finally(() => (this.tableRelevant.tableLoading = false))
      this.tableRelevant.tableDataSource = data.items
      this.tableRelevant.tablePagination.total = data.totalCount
      this.tableRelevant.tablePagination.current = data.pageIndex
    },
    handleReset() {
      this.searchForm = {
        term: undefined,
        type: undefined,
        examName: undefined,
        examTime: undefined,
        operatorId: undefined,
        status: null,
      }
      this.getList(true)
    },
    async onEdit(record) {
      const options = {
        id: record.id,
        exam: { ...record },
      }
      await this.$refs.uploadGradeRef.showModal(options)
      this.getList(1)
    },
    async onDownload(record) {
      try {
        const params = {
          id: record.id,
        }
        this.$set(record, 'downLoadLoading', true)
        const { data } = await this.$http.ReportService.downloadGradeExam(params)
        if (!data.length) return
        const columns = [
          '学校名称',
          '学生id',
          '姓名',
          '性别',
          '出生日期',
          '年级',
          '班级',
          '语文成绩（必填）',
          '数学成绩（必填）',
          '英语成绩（必填）',
          '物理成绩',
          '化学成绩',
          '生物成绩',
          '政治成绩',
          '历史成绩',
          '地理成绩',
        ]
        const exportKeys = [
          'organziationName',
          'organizationUserId',
          'realName',
          'gender',
          'birthday',
          'gradeName',
          'className',
          'chineseScore',
          'mathScore',
          'englishScore',
          'physicsScore',
          'chemistryScore',
          'biologyScore',
          'politicsScore',
          'historyScore',
          'geographyScore',
        ]
        const exportData = []
        for (let i = 0; i < data.length; i++) {
          const item = data[i]
          const reulst = []
          exportKeys.forEach((key) => {
            let val = Array.isArray(item[key]) ? item[key].join('，') : item[key]
            if (key == 'gender') {
              val = val == 1 ? '男' : '女'
            }
            if (key == 'organziationName') {
              val = record.organziationName
            }
            if (key == 'birthday') {
              val = moment(val).format('YYYY-MM-DD')
            }
            reulst.push(String(val ?? ''))
          })
          exportData.push(reulst)
        }
        arrayToXlsx(exportData, {
          columns,
          fileName: record.examName + '成绩.xlsx',
          generate: (obj) => {
            obj.aoa['!cols'] = Array.from({ length: columns.length }, (_, i) => (i + 1 === columns.length ? { wpx: 140 } : { wpx: 100 }))
          },
        })
      } finally {
        this.$set(record, 'downLoadLoading', false)
      }
    },
    async onDelete(record) {
      await this.$http.ReportService.delGradeExam({ id: record.id })
      this.$message.success('操作成功')
      this.getList(true)
    },
    async handleUploadGrade() {
      const options = {
        organizationId: this.$route.query.orgId,
      }
      await this.$refs.uploadGradeRef.showModal(options)
      this.getList(1)
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    async handleChangeStatus(record) {
      await this.$http.ReportService.updateGradeStatus({ id: record.id })
      this.$message.success('操作成功')
      this.getList(true)
    },
    getOrgList() {
      this.$http.loadAllByType({ isOnlySuperior: false, orgType: 1 }).then((res) => {
        const { data } = res.data
        this.orgList = data
      })
    },
    getAdminList() {
      this.$http.Mechanism.GetOrganizationAdmin().then((res) => {
        const { data } = res
        this.adminList = data
      })
    },
  },
}
</script>
<style scoped>
.grade-search-form .ant-form-item {
  display: flex;
}

.grade-search-form ::v-deep .ant-form-item-control-wrapper {
  flex: 1;
}
.a-status {
  cursor: pointer;
}
.remark {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
